<template>
    <section class="dekonstrukt-desctiption">
        <div class="container">
            <div class="row m-0 dekonstrukt-desctiption__row">
                <div class="col p-0 dekonstrukt-desctiption__column">
                    <TextBlock
                        :heading="'Trademark Search'"
                    >
                        <p class="body-copy body-copy--align-center">
                            Simply tell us the goods/services you’re interested in and DeKonstrukt will run a search
                            of the UK and EU TM databases and offer you a preliminary view on whether your brand
                            name is available to secure.
                        </p>

                    </TextBlock>
                </div>

                <div  class="col p-0 dekonstrukt-desctiption__column">
                    <TextBlock
                        :heading="'Domain Name Search'"
                    >
                        <p class="body-copy body-copy--align-center">
                            Securing domain names to support your brand name is a key ingredient. Check their
                            availability here.
                        </p>
                    </TextBlock>
                </div>

                <div  class="col p-0 dekonstrukt-desctiption__column">
                    <TextBlock
                        :heading="'Social Media Search'"
                    >
                        <p class="body-copy body-copy--align-center">
                            Run a thorough trawl of the web in terms of how your candidate name is being used across
                            a range of social media.
                        </p>
                    </TextBlock>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
    import TextBlock from "@/components/blocks/TextBlock";

    export default {
        name: 'DekonstruktDescription',
        components: {
            TextBlock
        }
    }
</script>